export const localCache = {
  getCache: (key) => {
    return sessionStorage.getItem(key);
  },
  setCache: (key, value) => {
    sessionStorage.setItem(key, value);
  },
  removeCache: (key) => {
    sessionStorage.removeItem(key);
  },
  clearCache: () => {
    sessionStorage.clear();
  },
};
